export const DEFAULT_STROKE_WIDTH = 2;
export const MIN_DYNAMIC_STROKE_WIDTH = 2;
export const MAX_DYNAMIC_STROKE_WIDTH = 10;
export const INRIX_VOLUME_LINE_COLOR = "rgba(34, 139, 230, 0.8)";

export const calculateSqrtScaledStrokeWidth = (
  value: number | null,
  minValue: number | null | undefined,
  maxValue: number | null | undefined,
): number => {
  if (
    value === null ||
    minValue === null ||
    minValue === undefined ||
    maxValue === null ||
    maxValue === undefined ||
    !Number.isFinite(value) ||
    !Number.isFinite(minValue) ||
    !Number.isFinite(maxValue) ||
    maxValue <= minValue
  ) {
    return DEFAULT_STROKE_WIDTH;
  }

  const normalized = Math.max(
    0,
    Math.min(1, (value - minValue) / (maxValue - minValue)),
  );
  const scaled = Math.sqrt(normalized);
  return (
    MIN_DYNAMIC_STROKE_WIDTH +
    scaled * (MAX_DYNAMIC_STROKE_WIDTH - MIN_DYNAMIC_STROKE_WIDTH)
  );
};
